<script>
import ListComponent from './components/ListComponent';

export default {
  page: {
    title: '服務項目',
    meta: [{ name: 'description', content: 'Prepaid List' }],
  },
  components: {
    ListComponent,
  },
  filters: {},

  props: {
    merchantProducts: {
      type: Array,
      required: true,
    },
    serviceCategory: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  methods: {},
};
</script>

<template>
  <ListComponent type="commodityManage" :merchant-products="merchantProducts" :service-category="serviceCategory" :table-checkbox-show="true"> </ListComponent>
</template>

<style lang="scss" module></style>